const elecPriceEn = {
  elPriceLang: {
    请输入站点名称搜索: 'Please enter the station name',
    暂无数据: 'No data available',
    电价配置: 'Electricity price allocation',
    模板管理: 'Template management',
    动态电价: 'Dynamic electricity price',
    为对应月份选择模板后请点击绑定按钮以完成应用更换模板前请先点击解绑按钮才可重新选择:
      'After selecting the template for the month, click the "Bind" button to complete the application. Please click the "Unbind" button before replacing the template.',
    年份: 'Year',
    选择年份: 'Please select a year',
    '1月': 'January',
    '2月': 'February',
    '3月': 'March',
    '4月': 'April',
    '5月': 'May',
    '6月': 'June',
    '7月': 'July',
    '8月': 'August',
    '9月': 'September',
    '10月': 'October',
    '11月': 'November',
    '12月': 'December',
    请选择: 'Please select',
    绑定: 'Binding',
    当前: 'At present',
    解绑: 'Unbind',
    查看: 'Examine',
    模板详情: 'Template details',
    模板名称: 'Template name',
    模板状态: 'Template state',
    使用中: 'In use',
    未使用: 'Unused',
    使用情况: 'Use condition',
    模板标签: 'Template tag',
    开始时间: 'Start time',
    结束时间: 'Finish time ',
    时段: 'Time frame',
    买入电价元kWh: 'Purchase price (Yuan /kWh)',
    卖出电价元kWh: 'Selling price (Yuan /kWh)',
    尖: 'Tip',
    峰: 'Peak',
    平: 'Flat',
    谷: 'Valley',
    确定电价: 'Confirm',
    是否确认解绑该模板: 'Do you want to unbind the template?',
    提示: 'Hint',
    取消: 'Cancel',
    点击引用模板按钮可将公共模板中的电价模板直接引用至当前页面下:
      'Click the "Reference Template" button to directly reference the electricity price template in the "Public template" to the current page！',
    请输入内容例如模版名称标签: 'Please enter the content, such as template name, label',
    查询: 'Query',
    重置: 'Reset',
    引用模板: 'Reference template',
    创建模板: 'Create a template',
    模版名称: 'Template name',
    状态: 'State',
    标签: 'Label',
    创建人: 'Founder',
    创建时间: 'Creation time',
    操作: 'Operation',
    引用创建: 'Reference creation',
    编辑: 'Edit',
    删除: 'Delete',
    请选择站点: 'Please select a site!',
    该模版正在使用中暂不支持删除请解绑后再操作: 'The template is in use, do not support deletion, please unbind after operation!',
    是否确认删除该模板: 'Do you want to delete the template?',
    电价管理: 'Electricity price management',
    选择需要引用的模板后点击确认按钮可将对应模板引用至模板管理中: 'Select the template you want to reference and click OK to reference the template to template management.',
    确定引用: 'Definitive reference',
    请选择引用模板: 'Please select a reference template!',
    模版编辑: 'Template editor',
    基础信息: 'Basic information',
    时段与电价: 'Time period and price',
    请输入模版名称: 'Please enter a template name!',
    模版名称: 'Template name',
    标签名称: 'Label name',
    请输入标签名称: 'Please enter a label name!',
    生成: 'Generate',
    标签名称以空格分隔完成后回车或点击生成按钮即可生成标签每个标签最多可输入20个字符最多支持生成10个标签:
      'Label names are separated by Spaces. Press enter or click the "Generate" button to generate labels. A maximum of 20 characters can be entered for each label, and a maximum of 10 labels can be generated.',
    标签管理: 'Label management',
    点击编辑后可以勾选标签后进行删除操作: 'After clicking "Edit", you can select the label and delete it',
    确定修改: 'Definite modification',
    下一步: 'next step',
    最多还可添加: 'Can I add at most',
    个标签: 'Tags',
    单个标签字符长度不可超过20: 'A single label contains a maximum of 20 characters',
    请选择要删除的标签: 'Select the label you want to remove',
    模板中时段与电价被修改后数据将同步到已绑定的月份中请谨慎操作:
      'After the time period and electricity price in the template are modified, the data will be synchronized to the bound month. Exercise caution when performing this operation!',
    展开全部: 'Expand all',
    收起: 'Retract',
    时间编辑: 'Time editing',
    选择时间: 'Selection time',
    时段说明: 'Period specification',
    新增: 'Newly increased',
    电价编辑: 'Electricity price editing',

    买入价格: 'Purchase price',
    元: '',
    卖出价格: 'Sell price',
    确定添加: 'Definite addition',
    请选择开始时间: 'Please select a start time!',
    开始时间不可与结束时间相同: 'The start time cannot be the same as the end time!',
    选择结束时间: 'Please select a end time!',
    结束时间不可与开始时间相同: 'The end time cannot be the same as the start time!',
    请选择时间段类型: 'Please select a time period type!',
    请输入买入价格: 'Please enter the purchase price',
    '买入价格数字范围 0 - 10000': 'Purchase price number range 0 - 10000',
    小数点后不允许超过9位: 'No more than 9 digits are allowed after the decimal point',
    请输入卖出价格: 'Please enter sell price!',
    '卖出价格数字范围 0 - 10000': 'Sell price number range 0 - 10000',
    时间段存在冲突请重新配置: 'Time range conflict, please reconfigure!',

    同步电价: 'Synchronous tariff',
    请选择地区时区和起始时间后点击同步电价按钮平台将自动把对应电价数据与站点电价表同步:
      'After selecting the region, time zone and start time, click the button of synchronous electricity price, and the platform will automatically synchronize the corresponding electricity price data with the site electricity price meter.',
    数据来源: 'Data sources',
    国家: 'Country',
    地区: 'Region',
    起始日期: 'Start date',
    请确认是否将以下电价数据与电站同步: 'Please confirm whether the following electricity price data will be synchronized with the power station?',
    起始日: 'Start date',
    否: 'No',
    是: 'Yes',

    当前同步电价未绑定到达同步日期后将停止更新电价信息请及时配置电价以免影响电站收益统计:
      'The current synchronous electricity price is not bound, and will stop updating the electricity price information after reaching the synchronization date. Please configure the electricity price in time to avoid affecting the revenue statistics of the power station!',
    日期: 'Date',
    选择日期: 'Please select a date',
    暂未配置电价请点击同步电价: 'Electricity price has not been configured, please click Sync electricity price.',
    已同步至: 'Synchronized to',
    列表: 'List',
    趋势: 'Trend',
    电价: 'Electrovalence',
    '请确认是否修改当前电价，修改后仅保留上传修改数据！': 'Please confirm whether to modify the current electricity price, and only upload the modified data after modification!',
    请输入电价: 'Please enter electricity price!',
    '电价数值范围 1-9999 整数': 'Electricity price Value range 1 to 9999 integer',
    电价表: 'Electrovalence meter',
    暂未获取到当日电价: 'The electricity price of the day has not been obtained',
    请确认是否解除同步解除同步后将停止获取新的电价信息: 'Please confirm whether the synchronization is unsynchronized, after the synchronization will stop getting new electricity price information!'
  }
}
export default elecPriceEn
